import React, { useEffect, useState } from 'react';
import { Popover, Select } from 'antd';
import styles from "./leftcontainer.module.scss";
import alertyellow from "../../styles/images/alertyellow.svg";
import {
  content, contentTurnMic, contentTurnMicOff,
  contentTurnVideo, contentTurnVideoOff, contentVideo,
  popOverWrapper, turnpopOverWrapper
} from '../leftContainer/guestconstant';
import { askPermission, deviceDetailInfo, mediaDeviceAdded, updateAudioStream, updateVedioStream } from '../../base/video_common';
import store from '../../store/redux-store/root_store';
import { useDispatch } from 'react-redux';
import { meetActions } from '../../store/slices/meet_slice/meetslice';
import { toggleAudio, toggleVideo } from '../../services/meetService';
import { videoCallService } from '../../base/service/videoCallService';
// import { VideoAudioToggle } from './videoAudioToggle';

export const LeftContainer = () => {
  const [meetInfo, setMeetInfo] = useState
    ({
      video: true, videoStream: "", videoDisabled: false,
      audio: true, audioStream: "", audioDisabled: false, isLoading: false
    });
  let dispatch = useDispatch();
  // const { startAudio, startVideo, meetInfo, handleAudio, handleVideo, askPermission } = VideoAudioToggle();
  useEffect(() => {
    //startAudio();
    //startVideo();
    askPermission();
    if (navigator?.mediaDevices) {
      navigator.mediaDevices.ondevicechange = function (event) {
        startVideo();
        startAudio();
      };
    };
  }, []);

  const singlePrompt = async () => {
    return new Promise(async (resolve, reject) => {
      let errorCallback = (error: any) => {
        if ((error.name === 'NotAllowedError') || (error.name === 'PermissionDismissedError') || (error.name === 'NotFoundError') || error.name === "NotReadableError") {
          // toggleVideoDelay(true);
          reject("there is no device");
        }
      };
      var constraints: any = {
        audio: true,
        video: {
          width: 1280, height: 720, zoom: false
        },
        aspectRatio: { exact: 1.7777777778 },
        facingMode: "environment"
      };
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        await navigator.mediaDevices.getUserMedia(constraints)
          .then((stream: any) => {
            console.log(stream, "stream=====")
            resolve(stream);
          }, errorCallback);
      }
    });
  }

  const handlePermission = (type: string, track: MediaStreamTrack) => {
    if (type === "audio") {
      setMeetInfo((prevState: any) => ({ ...prevState, audioDisabled: false }));
    }
    if (type === "video") {
      setMeetInfo((prevState: any) => ({ ...prevState, videoDisabled: false }));
    }
  };

  const askPermission = async () => {
    let data: any = singlePrompt();

    await data.then((stream: any) => {


      let audioStream: any = new MediaStream();
      audioStream.addTrack(stream.getAudioTracks()[0]);
      let videoStream: any = new MediaStream();
      videoStream.addTrack(stream.getVideoTracks()[0]);

      setMeetInfo((prevState: any) => ({ ...prevState, audioStream: audioStream }));
      updateAudioStream(audioStream);
      const tracks = stream.getTracks();
      tracks.forEach(function (track: any) {
        handlePermission(track.kind, track);
      });
      var audio: any = document.querySelector("audio");
      audio.srcObject = audioStream;
      deviceDetailInfo("audio", true, "success");



      setMeetInfo({ ...meetInfo, audioStream: audioStream, audio: true, isLoading: false });
      updateVedioStream(videoStream);
      var video: any = document.getElementById("joinPageVideo");
      if (video) {
        video.srcObject = stream;
        video.autoplay = true;
      }

      mediaDeviceAdded("add");
      deviceDetailInfo("video", true, "success");
      setTimeout(function () {
        setMeetInfo({ ...meetInfo, videoStream: videoStream, video: true, isLoading: false });
        toggleVideo(true);
        // toggleVideoDelay(true);
      }, 800);
    })
      .catch((e: any) => {
        console.log("e error is", e);
        // toggleVideoDelay(true);
        startVideo();
        startAudio();

      })

  };

  const handleAudio = () => {
    let { audio, audioStream }:any = meetInfo;
    setMeetInfo({ ...meetInfo, audio: !audio });
    console.log("audio >>>>>>", audio);
    toggleAudio(audio);
    if (audioStream) {
      console.log("audioStream",audioStream); 
      setMeetInfo((prevState: any) => ({ ...prevState, audioDisabled: false }));
      const tracks = audioStream.getTracks();
      if (audio) {
        console.log("if====");
        tracks.forEach(function (track: any) {
          if (track.kind === "audio") {
            track.enabled = false;
          }
        });
      }
      else {
        console.log("else====");
        
        tracks.forEach(function (track: any) {
          if (track.kind === "audio") {
            track.enabled = true;
          }
        });
      }
    }
  };


  const handleVideo = (status: boolean) => {
    let { video, videoStream, isLoading }:any = meetInfo;
    if (status && !video && !isLoading) {
      startVideo();
    }
    else if (!status && !isLoading && video) {
      if (videoStream) {
        setMeetInfo({ ...meetInfo, isLoading: true });
        const tracks = videoStream.getTracks();
        tracks.forEach(function (track: MediaStreamTrack) {
          if (track.kind === "video" && track.readyState === 'live') {
            track.enabled = false;
            track.stop();
          }
        });
        setMeetInfo({ ...meetInfo, videoStream: "", video: false, isLoading: false });
        toggleVideo(false);
      }
      //setMeetInfo({...meetInfo,videoStream:mediaStream,video: true});
    }

    // if (videoStream) {
    //   setMeetInfo({...meetInfo,video: !video });
    //   toggleVideo(!video);
    //   const tracks = videoStream.getTracks();
    //   if (video) {
    //     tracks.forEach(function(track: MediaStreamTrack) {
    //       if (track.kind === "video" && track.readyState === 'live') {
    //         track.enabled = false;
    //         track.stop();
    //       }
    //     });
    //   } else {
    //     startVideo();
    //   }
    // } else {
    //   startVideo();
    // }
  };

  const startVideo = () => {
    let { videoStream } = meetInfo;
    if (videoStream === "") {
      setMeetInfo({ ...meetInfo, isLoading: true });
      if (navigator?.mediaDevices) {
        navigator.mediaDevices
          .getUserMedia({ video: { width: 1280, height: 720 } })
          .then(function (mediaStream:any) {
            updateVedioStream(mediaStream);
            const tracks = mediaStream.getTracks();
            tracks.forEach(function (track: any) {
              handlePermission(track.kind, track);
            });
            var video: any = document.getElementById("joinPageVideo");
            if (video) {
              video.srcObject = mediaStream;
              video.autoplay = true;
            }

            mediaDeviceAdded('add');
            deviceDetailInfo('video', true, 'success');
            let delay = 1200;
            var browserUa = navigator.userAgent.toLowerCase();

            if (browserUa.indexOf("safari") > -1 && browserUa.indexOf("chrome") < 0) delay = 800
            setMeetInfo({ ...meetInfo, videoStream: mediaStream, video: true, isLoading: false });

            setTimeout(function () {
              toggleVideo(true);
              // toggleVideoDelay(true);
            }, delay);
          })
          .catch(function (err: any) {
            mediaDeviceAdded('remove');
            toggleVideo(false);
            // toggleVideoDelay(true);
            setMeetInfo((prevState: any) => ({ ...prevState, videoDisabled: true, videoStream: "", isLoading: false }));
            let error: string = "Can't find your camera";
            if (err.toString().includes("denied")) { error = 'Video Permission denied'; }
            deviceDetailInfo('video', false, error);
            let { currdeviceinfo } = store.getState().meetingReducer || [];
            let input: any = {};
            input.socketId = currdeviceinfo['conId'];
            input.video = false;
            if (input.socketId !== "") { videoCallService.videoStatus(input); }
          });
      }
    }
  };

  const startAudio = async () => {
    console.log("Start audio calling");
    if (navigator?.mediaDevices) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(function (mediaStream) {
          setMeetInfo((prevState: any) => ({ ...prevState, audioStream: mediaStream }));
          updateAudioStream(mediaStream);
          const tracks = mediaStream.getTracks();
          tracks.forEach(function (track: any) {
            handlePermission(track.kind, track);
          });
          var audio: any = document.querySelector("audio");
          audio.srcObject = mediaStream;
          deviceDetailInfo('audio', true, 'success');
        })
        .catch(function (err) {
          mediaDeviceAdded('remove');
          toggleAudio(true);
          setMeetInfo((prevState: any) => ({ ...prevState, audioDisabled: true, audioStream: "" }));
          let error: string = "Can't find microphone";
          if (err.toString().includes("denied")) { error = 'Audio Permission denied'; }
          deviceDetailInfo('audio', false, error);
        });
    }
  };
  return (<>
    <div className={styles.videoPreviewsec}>
      <div className={styles.videoPreview}>
        <video id="joinPageVideo" className={styles.videosections} 
          style={{ display: meetInfo.video ? "block" : "none" }} muted={true}></video>
          <div className="joinpagenovideo">Your camera has been turned off</div>
{/* 
        {!meetInfo.audioDisabled && !meetInfo.audio && <p className={styles.muteNotifiactionSec}>
          <span className={`icon_Audio-off ${styles.warIconClr}`}></span>
          <span className={styles.warningtxtsec}> Microphone OFF </span></p>}
        {!meetInfo.video &&
          <p className={styles.deviceCondetailsalert}>Your camera has been turned off</p>}
        <div className={styles.deviceDetails}>
          <ul className={styles.deviceDetailslist}>

            {meetInfo.audioDisabled && <li onClick={() => handleAudio()}>
              <Popover content={content} overlayClassName={popOverWrapper} trigger="hover">
                <span className={`${styles.nohover} ${styles.audioUnmute}`}>
                  <img src={alertyellow} alt="audio muted" /></span>Mute</Popover>
            </li>}

            {!meetInfo.audioDisabled && <li onClick={() => handleAudio()}>
              <Popover content={meetInfo.audio ? contentTurnMic : contentTurnMicOff}
                overlayClassName={turnpopOverWrapper} trigger="hover">
                <span className={!meetInfo.audio ? styles.audioMute : styles.audioUnmute}></span>Mute</Popover></li>}

            {meetInfo.videoDisabled && <li onClick={() => handleVideo(!meetInfo.video)}>
              <Popover content={contentVideo} overlayClassName={popOverWrapper}
                trigger="hover">
                <span className={`${styles.nohover} ${styles.videoUnmute}`}
                >
                  <img src={alertyellow} alt="Video muted" /></span>Video</Popover>
            </li>}

            {!meetInfo.videoDisabled && <li onClick={() => handleVideo(!meetInfo.video)}>
              <Popover content={meetInfo.video ? contentTurnVideo : contentTurnVideoOff}
                overlayClassName={turnpopOverWrapper} trigger="hover">
                <span className={!meetInfo.video ? styles.videoMute : styles.videoUnmute}></span>Video</Popover></li>}

          </ul>
        </div> */}

        <div className={styles.videobottom}>
          <div className={styles.lefts}>
            <Select
              className={`${styles.selects} antSelect`}
              placeholder="Internal Microphone"
              suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
                <path d="M4.00022 3.93471C3.59855 3.93471 3.22155 3.77844 2.93802 3.49397L0.36902 0.917775C0.17402 0.722441 0.174687 0.406042 0.37002 0.210775C0.565954 0.0161086 0.882687 0.0161085 1.07735 0.212108L3.64602 2.78831C3.83515 2.97711 4.16555 2.97711 4.35402 2.78831L6.92302 0.212108C7.11769 0.0161751 7.43442 0.0161752 7.63035 0.210775C7.82569 0.406109 7.82629 0.722508 7.63135 0.917775L5.06235 3.49397C4.77882 3.77851 4.40162 3.93471 4.00022 3.93471Z" fill="white" />
              </svg>}
            ></Select>
            <Select
              className={`${styles.selects} antSelect`}
              placeholder="Internal Speaker"
              suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4" fill="none">
                <path d="M4.00022 3.93471C3.59855 3.93471 3.22155 3.77844 2.93802 3.49397L0.36902 0.917775C0.17402 0.722441 0.174687 0.406042 0.37002 0.210775C0.565954 0.0161086 0.882687 0.0161085 1.07735 0.212108L3.64602 2.78831C3.83515 2.97711 4.16555 2.97711 4.35402 2.78831L6.92302 0.212108C7.11769 0.0161751 7.43442 0.0161752 7.63035 0.210775C7.82569 0.406109 7.82629 0.722508 7.63135 0.917775L5.06235 3.49397C4.77882 3.77851 4.40162 3.93471 4.00022 3.93471Z" fill="white" />
              </svg>}
            ></Select>
          </div>
          <div className={styles.rights}>

            <ul>
            {meetInfo.audio &&  <li onClick={() => handleAudio()}>
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">

<rect width="36" height="36" rx="18" fill="#F5F6F7"/>
<g clip-path="url(#clip0_3317_79334)">
<path d="M18.0004 21.2654C19.7152 21.2654 21.1108 19.8699 21.1108 18.155V11.5847C21.1108 9.86995 19.7153 8.47485 18.0004 8.47485C16.2855 8.47485 14.8905 9.86985 14.8905 11.5847V18.155C14.8905 19.8698 16.2855 21.2654 18.0004 21.2654ZM16.3905 11.5847C16.3905 10.697 17.1127 9.97485 18.0004 9.97485C18.8886 9.97485 19.6108 10.697 19.6108 11.5847V18.155C19.6108 19.0432 18.8886 19.7654 18.0004 19.7654C17.1127 19.7654 16.3905 19.0432 16.3905 18.155V11.5847Z" fill="black"/>
<path d="M24.4408 18.0549V15.0446C24.4408 14.6305 24.1049 14.2946 23.6908 14.2946C23.2767 14.2946 22.9408 14.6305 22.9408 15.0446V18.0549C22.9408 20.6628 20.725 22.7849 18.0004 22.7849C15.2758 22.7849 13.0605 20.6628 13.0605 18.0549V15.0446C13.0605 14.6305 12.7246 14.2946 12.3105 14.2946C11.8964 14.2946 11.5605 14.6305 11.5605 15.0446V18.0549C11.5605 21.2442 14.0522 23.8778 17.2504 24.2389V26.2243H13.8305C13.4716 26.2243 13.1806 26.5154 13.1806 26.8748C13.1806 27.2341 13.4716 27.5252 13.8305 27.5252H22.1703C22.5297 27.5252 22.8207 27.2341 22.8207 26.8748C22.8207 26.5154 22.5297 26.2243 22.1703 26.2243H18.7504V24.2389C21.9487 23.8778 24.4408 21.2442 24.4408 18.0549Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_3317_79334">
<rect width="24" height="24" fill="white" transform="translate(6 6)"/>
</clipPath>
</defs>
</svg>

              
              </li> }
            {!meetInfo.audio && <li onClick={() => handleAudio()}>
              {/* <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none">
                <path d="M6.99996 13.2652C8.71476 13.2652 10.1104 11.8697 10.1104 10.1548V3.58451C10.1104 1.86971 8.71486 0.474609 6.99996 0.474609C5.28506 0.474609 3.89006 1.86961 3.89006 3.58451V10.1548C3.89006 11.8696 5.28506 13.2652 6.99996 13.2652ZM5.39006 3.58451C5.39006 2.69681 6.11226 1.97461 6.99996 1.97461C7.88816 1.97461 8.61036 2.69681 8.61036 3.58451V10.1548C8.61036 11.043 7.88816 11.7652 6.99996 11.7652C6.11226 11.7652 5.39006 11.043 5.39006 10.1548V3.58451Z" fill="black" />
                <path d="M13.4404 10.0547V7.04441C13.4404 6.63031 13.1045 6.29441 12.6904 6.29441C12.2763 6.29441 11.9404 6.63031 11.9404 7.04441V10.0547C11.9404 12.6626 9.72456 14.7847 6.99996 14.7847C4.27536 14.7847 2.06006 12.6626 2.06006 10.0547V7.04441C2.06006 6.63031 1.72416 6.29441 1.31006 6.29441C0.895959 6.29441 0.560059 6.63031 0.560059 7.04441V10.0547C0.560059 13.244 3.05176 15.8776 6.24996 16.2387V18.2241H2.83006C2.47116 18.2241 2.18016 18.5151 2.18016 18.8745C2.18016 19.2339 2.47116 19.5249 2.83006 19.5249H11.1699C11.5293 19.5249 11.8203 19.2339 11.8203 18.8745C11.8203 18.5151 11.5293 18.2241 11.1699 18.2241H7.74996V16.2387C10.9483 15.8776 13.4404 13.2439 13.4404 10.0547Z" fill="black" />
              </svg> */}

<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">

<rect width="36" height="36" rx="18" fill="#F5F6F7"/>
<g clip-path="url(#clip0_3317_79346)">
<path d="M16.3891 13.965L19.6091 17.195L20.3591 17.955L21.0691 18.665C21.0991 18.495 21.1091 18.325 21.1091 18.155V11.585C21.1091 9.865 19.7091 8.475 17.9991 8.475C16.2791 8.475 14.8891 9.865 14.8891 11.585V12.455L15.6391 13.205L16.3891 13.965Z" fill="black"/>
<path d="M24.4391 18.055V15.045C24.4391 14.625 24.0991 14.295 23.6891 14.295C23.2791 14.295 22.9391 14.625 22.9391 15.045V18.055C22.9391 18.775 22.7691 19.455 22.4591 20.065L23.5591 21.175C24.1191 20.255 24.4391 19.195 24.4391 18.055Z" fill="black"/>
<path d="M26.6791 26.775C26.5291 26.925 26.3391 26.995 26.1491 26.995C25.9591 26.995 25.7691 26.925 25.6191 26.775L21.8691 23.015C20.9791 23.675 19.9191 24.115 18.7491 24.245V26.225H22.1791C22.5391 26.225 22.8291 26.515 22.8291 26.875C22.8291 27.235 22.5391 27.525 22.1791 27.525H13.8291C13.4691 27.525 13.1791 27.235 13.1791 26.875C13.1791 26.515 13.4691 26.225 13.8291 26.225H17.2491V24.245C14.0391 23.885 11.5491 21.245 11.5491 18.055V15.045C11.5491 14.625 11.8891 14.295 12.2991 14.295C12.7091 14.295 13.0491 14.625 13.0491 15.045V18.055C13.0491 20.665 15.2691 22.785 17.9991 22.785C19.0391 22.785 20.0091 22.475 20.8091 21.945L19.6491 20.775C19.1691 21.085 18.6091 21.255 17.9991 21.255C16.2791 21.255 14.8891 19.865 14.8891 18.155V15.995L9.31906 10.405C9.02906 10.115 9.02906 9.635 9.31906 9.345C9.60906 9.055 10.0891 9.055 10.3791 9.345L26.6791 25.715C26.9691 26.005 26.9691 26.485 26.6791 26.775Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_3317_79346">
<rect width="24" height="24" fill="white" transform="translate(6 6)"/>
</clipPath>
</defs>
</svg>



              
              </li>}
             
              {meetInfo.video &&  <li onClick={() => handleVideo(!meetInfo.video)}>
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">

<rect width="36" height="36" rx="18" fill="#F5F6F7"/>
<g clip-path="url(#clip0_3317_79336)">
<path d="M26.2357 12.7873C25.9186 12.7873 25.6047 12.8809 25.3287 13.0575L22.6513 14.773C22.5594 13.7295 22.2966 12.5625 21.4477 11.7161C20.2891 10.5584 18.6739 10.3622 17.1025 10.323C15.8137 10.29 14.9018 10.29 13.6139 10.323C12.0411 10.3631 10.4254 10.5593 9.2651 11.7179C8.062 12.9282 8.0294 14.7209 8.0031 16.1613L8 19.6949L8.0031 19.8474C8.0294 21.2878 8.062 23.0805 9.2673 24.2827C10.4276 25.4421 12.0424 25.6375 13.613 25.6758C14.2574 25.6927 14.8077 25.7017 15.3575 25.7017C15.9078 25.7017 16.4576 25.6928 17.1011 25.6758C18.673 25.6366 20.2878 25.4412 21.4477 24.2836C22.2952 23.4372 22.5585 22.2727 22.6508 21.226L25.3287 22.9413C25.6047 23.1179 25.9187 23.2115 26.2357 23.2115C27.2083 23.2115 27.9998 22.3669 27.9998 21.3296V14.6699C27.9998 13.6317 27.2083 12.7873 26.2357 12.7873ZM21.3384 19.9973C21.3125 21.3191 21.2274 22.5677 20.48 23.3142C19.7058 24.0866 18.5558 24.2694 17.0659 24.306C15.8039 24.3399 14.9142 24.3399 13.6478 24.306C12.1597 24.2703 11.0096 24.0875 10.235 23.3133C9.4216 22.5017 9.3957 21.0782 9.3726 19.8216L9.3699 16.3406L9.3726 16.1872C9.3958 14.9296 9.4217 13.5035 10.235 12.6848C11.0078 11.9133 12.1583 11.7305 13.6496 11.693C14.2806 11.6761 14.8193 11.6671 15.3576 11.6671C15.8963 11.6671 16.4345 11.676 17.0673 11.693C18.5563 11.7305 19.7068 11.9133 20.4801 12.6857C21.2262 13.4295 21.3122 14.6764 21.3385 15.9964L21.3384 19.9973ZM26.6299 21.3298C26.6295 21.7267 26.3177 21.9479 26.0676 21.7873L22.7083 19.6359V16.364L26.068 14.2117C26.3173 14.0521 26.6294 14.2723 26.6299 14.6701V21.3298Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_3317_79336">
<rect width="24" height="24" fill="white" transform="translate(6 6)"/>
</clipPath>
</defs>
</svg>




              
              </li>}
              {!meetInfo.video && <li  onClick={() => handleVideo(!meetInfo.video)}>
              <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">

<rect width="36" height="36" rx="18" fill="#F5F6F7"/>
<g clip-path="url(#clip0_3317_79350)">
<path d="M22.3287 19.8042C22.3378 19.2041 22.3469 18.5949 22.3378 18.004C22.3378 17.4039 22.3378 16.8038 22.3287 16.1947C22.3014 14.7399 22.3105 12.8943 21.1831 11.776C20.0921 10.685 18.5102 10.5305 17.0191 10.4941C16.3281 10.4759 15.7462 10.4668 15.1645 10.4668C14.5734 10.4668 13.9916 10.4759 13.3097 10.4941C13.146 10.4941 12.9823 10.5032 12.8096 10.5123L22.3287 20.0587V19.8042Z" fill="black"/>
<path d="M26.8411 13.1398C26.6484 13.1398 26.451 13.1942 26.2645 13.3136L22.8822 15.4804V20.5199L26.2645 22.6865C26.451 22.8059 26.6486 22.8606 26.8412 22.8606C27.4455 22.8606 27.9998 22.3244 27.9998 21.5749V14.4253C27.9998 13.6762 27.4454 13.1398 26.8411 13.1398Z" fill="black"/>
<path d="M10.0095 9.01116C9.7436 8.74396 9.3121 8.74396 9.0453 9.00936C8.7785 9.27476 8.7776 9.70636 9.0435 9.97356L10.1406 11.0752C9.7822 11.2472 9.4417 11.4801 9.1456 11.776C8.0182 12.9034 8.0273 14.749 8 16.2038V19.8041C8.0273 21.2588 8.0182 23.1044 9.1456 24.2227C10.2276 25.3138 11.8186 25.4683 13.3097 25.5047C13.9916 25.5229 14.5734 25.532 15.1645 25.532C15.7463 25.532 16.3282 25.5229 17.0191 25.5047C18.5011 25.4683 20.0921 25.3138 21.1831 24.2227C21.5437 23.8621 21.7958 23.4204 21.9598 22.9434L25.9885 26.9888C26.1217 27.1229 26.2966 27.1895 26.4715 27.1895C26.6455 27.1895 26.8195 27.1229 26.9527 26.9906C27.2195 26.7251 27.2204 26.2936 26.9545 26.0264L10.0095 9.01116Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_3317_79350">
<rect width="24" height="24" fill="white" transform="translate(6 6)"/>
</clipPath>
</defs>
</svg>


              
              </li>}
            </ul>
          </div>
        </div>
      </div>
    </div>

  </>);
};